import React, {Component} from "react";
import {reduxForm} from "redux-form/immutable";
import ActionButton from "../../components/ActionButton";
import FormError from "../../components/forms/FormError";
import CreditCardWithSelection from "../../checkout/shared/CreditCardWithSelection";
import CreditCardList from "../../checkout/shared/CreditCardList";

class ChangeCreditCardForm extends Component {

  constructor(props) {
    super(props);
    this.handleCreditCardListChange = this.handleCreditCardListChange.bind(this);
  }

  render() {
    let {errors, handleSubmit, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 

    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <p>Current card</p>
          <CreditCardWithSelection 
            id="current" 
            selected={this.props.selectedId === "current"}
            card={this.props.selectedPaymentMethod} 
            onSelect={this.handleSelect.bind(this)} 
            />
          {this.renderOtherCards()}          
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton onClick={handleSubmit(values => this.props.onSubmit(values))} primary={true} label={submitLabel} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
          <ActionButton label="Add Card" active={!submitting} onClick={this.props.onAddCard} />
        </div>
      </form>
    )
  }

  renderOtherCards() {
    let otherPaymentMethods = this.props.paymentMethods.filter(x => x.get("default") === false);
    if (otherPaymentMethods.size > 0) {
      return (
        <React.Fragment>
          <p>Other cards</p>
          <CreditCardList
            cards={otherPaymentMethods}
            selectedId={this.props.selectedId}
            onChange={this.handleCreditCardListChange}
            />
        </React.Fragment>
      ) 
    } else {
      return null;
    }
  }

  handleSelect(id) {
    this.props.onSelect(id);
  }

  handleCreditCardListChange(id) {
    this.props.onSelect(id);
  }

}

const ReduxForm = reduxForm({
  form: "ChangeCreditCardForm"
})(ChangeCreditCardForm);

export default ReduxForm;